export { default as Messaging } from './components/pages/Messaging';

export const MessagingDynamic = () => import('./components/pages/Messaging');
